import React, { useState, useEffect } from 'react';
import liff from '@line/liff';
import { config } from '../config';
import { lonUpdateUID } from '../actions';
import DOMPurify from 'dompurify';

const liffId = config.liff_id.lonImmigrate;

function LONImmigration(props) {
  const [profile, setProfile] = useState({ userId: "" })
  const [transactionId, setTransactionId] = useState("")
  const [redirectUrl, setRedirectUrl] = useState("")
  const [error, setError] = useState(false);

  useEffect(() => {

    initialize()
  }, []);


  const initialize = async () => {
    if (liff.isInClient()) {
      try {
        await liff.init({
          liffId,
          withLoginOnExternalBrowser: true,
        });

        const profile = await liff.getProfile();

        setProfile(profile)

        console.log(props.location.search)
        const params = JSON.parse(atob(props.location.search.split("?data=")[1]));
        console.log(params)
        setTransactionId(params.transactionId)
        setRedirectUrl(params.redirectUrl)
        await updateLineUUID(params.transactionId, params.redirectUrl, profile.userId)
      } catch (error) {
        console.log(error)
        setError('Catch get profile')
      }
      // end
    } else {
      setError('Not liff client')
    }
  };


  const updateLineUUID = async (transactionId, redirectUrl, lineuid) => {
    const response = await lonUpdateUID({ transactionId, redirectUrl, lineuid })
    console.log(response)
    // window.location.href = redirectUrl;
    const sanitizedUrl = DOMPurify.sanitize(redirectUrl);
    window.location = sanitizedUrl;
    return;
  };

  if (error && error === 'Not liff client') {
    return (<h2>You didn't open LIFF with Line browser</h2>)
  }

  if (error && error === 'Catch get profile') {
    return (<h2>You didn't open LIFF with Line browser</h2>)
  }

  // return (<div>
  //   <p>transactionId: {transactionId}</p>
  //   <p>redirectUrl: {redirectUrl}</p>
  //   <p>LineUUID: {profile?.userId || '-'}</p>
  // </div>);

  return (
    <>
      <div className="text-center" style={{ margin: '40px 0' }}>
        {
          error && (error === 'Not liff client' || error === 'Catch get profile') ?
            <h2>You didn't open LIFF with Line browser</h2> : ''
        }
        <div className="loading"></div>
      </div>
    </>
  )
}

export default LONImmigration;
